import { render, staticRenderFns } from "./MembershipItem.vue?vue&type=template&id=3628041a&scoped=true&"
import script from "./MembershipItem.vue?vue&type=script&lang=js&"
export * from "./MembershipItem.vue?vue&type=script&lang=js&"
import style0 from "./MembershipItem.vue?vue&type=style&index=0&id=3628041a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628041a",
  null
  
)

export default component.exports